import { Space } from "antd";
import { FC, useEffect, useState } from "react";
import { useLoading } from "../../context/LoadingProvider/useLoading";
import { ActionButtonEnum } from "../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../enums/searchOptionEnum";
import useActionButtons from "../../hooks/useActionButtons";
import useSmartSearchParams, {
  SmartSearchParams,
} from "../../hooks/useSmartSearchParams";
import { Output } from "../../services/types";
import { isString } from "../../utils/stringUtils";
import Button from "../UI/Button";
import RangePicker, {
  RangePickerValue,
  RangePickerValues,
} from "../UI/RangePicker";
import SmartSearch from "../UI/SmartSearch";
import DefaultFormParserLayout from "./default-form-parser-layout";
import DateInput from "../UI/DateInput";
import { SearchStatusEnum } from "../../enums/searchStatusEnum";
import dayjs from "dayjs";

export type SmartSeachDatePickerAndActionsLayoutProps = {
  searchBy: SearchOptionEnum[];
  validOnEmpty?: boolean;
  actions: ActionButtonEnum[];
  searchStatus: SearchStatusEnum[]
  onRefresh: (
    output: Output,
    params: SmartSearchParams,
    date: dayjs.Dayjs,
  ) => Promise<string | void>;
};

const SmartSeachDatePickerAndActionsLayout: FC<
  SmartSeachDatePickerAndActionsLayoutProps
> = ({ searchBy, actions, validOnEmpty = true, onRefresh, searchStatus }) => {

  const loading = useLoading();
  const [params, setParams] = useSmartSearchParams();
  const [search, setSearch] = useState("");
  const [validSearch, setValidSearch] = useState(false);
  const [report, setReport] = useState("");

  const {
    isToShowRefreshAction,
    isToShowSaveCSVAction,
    isToShowSavePDFAction,
  } = useActionButtons(actions);

  const TODAY = dayjs()

  const [date, setDate] = useState<dayjs.Dayjs>(TODAY);

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      refreshReport()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const res = await onRefresh(output, params, date);

    if (Output.isHTML(output) && isString(res)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="small" wrap>
        <SmartSearch
          autoFocus
          validOnEmpty={validOnEmpty}
          label="Smart Search"
          status={searchStatus.join()}
          searchBy={searchBy}
          onChange={(e: string) => setSearch(e)}
          value={search}
          onValidSearch={setValidSearch}
          onObjValueChange={(e: any) => setParams({ ...params, ...e })}
        />

        <DateInput
          defaultValue={TODAY}
          onChange={(e) => setDate(e)}
          format="MM-DD-YYYY"
          allowClear={false}
        />

        {isToShowRefreshAction && (
          <Button
            type="primary"
            disabled={!validSearch}
            onClick={() => refreshReport()}
          >
            Refresh
          </Button>
        )}

        {isToShowSaveCSVAction && (
          <Button
            type="primary"
            disabled={!validSearch}
            onClick={() => refreshReport(Output.CSV)}
          >
            Save as CSV
          </Button>
        )}

        {isToShowSavePDFAction && (
          <Button
            type="primary"
            disabled={!validSearch}
            onClick={() => refreshReport(Output.PDF)}
          >
            Save as PDF
          </Button>
        )}
      </Space>
    </DefaultFormParserLayout>
  );
};

export default SmartSeachDatePickerAndActionsLayout;
